import { render, staticRenderFns } from "./CreditRequest.vue?vue&type=template&id=06d2226d&scoped=true&"
import script from "./CreditRequest.vue?vue&type=script&lang=ts&"
export * from "./CreditRequest.vue?vue&type=script&lang=ts&"
import style0 from "./CreditRequest.vue?vue&type=style&index=0&id=06d2226d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2226d",
  null
  
)

export default component.exports